import {apiEventserviceEndpoint} from '@/config/config.js';
import { createApiClientDefault } from "@/services/baseservice.js"

const baseservice = createApiClientDefault(apiEventserviceEndpoint)


export default {
    async getAll() {
        return await baseservice.get('/persons',
        { baseURL: apiEventserviceEndpoint })
    },
};


